import React from 'react';
import { compareParameters } from '../../actions/parametersActions';
import './WizardSidebar.css';

const WizardSidebar = ({ activeProject, projectUpdateParameters, projectSourceParameters, modelGenerated, currentStep, onViewBom, onViewDrawing }) => {
    const hasParams = projectUpdateParameters && projectUpdateParameters.length > 0;
    const hasDrawing = activeProject && activeProject.hasDrawing;
    const isAssembly = activeProject && activeProject.isAssembly;
    const isReviewStep = currentStep === 2;

    return (
        <div className="wizard-sidebar">
            <div className="sidebar-section">
                <div className="sidebar-product-name">
                    {activeProject?.label || activeProject?.id || 'No product selected'}
                </div>
                <div className={`sidebar-status ${modelGenerated ? 'generated' : 'pending'}`}>
                    <span className="sidebar-status-dot" />
                    {modelGenerated ? 'Product Generated with Your Options as Selected' : 'Pending Update'}
                </div>
            </div>

            <div className="sidebar-section sidebar-params">
                <div className="sidebar-section-title">Configuration</div>
                {hasParams ? (
                    <div className="sidebar-param-list">
                        {projectUpdateParameters.map((param, index) => {
                            const sourceParam = projectSourceParameters
                                ? projectSourceParameters.find(p => p.name === param.name)
                                : null;
                            const changed = sourceParam && !compareParameters(param, sourceParam);

                            return (
                                <div key={param.name || index} className={`sidebar-param ${changed ? 'changed' : ''}`}>
                                    <div className="sidebar-param-name">{param.label || param.name}</div>
                                    <div className="sidebar-param-value">
                                        {param.value}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <div className="sidebar-empty">No parameters loaded</div>
                )}
            </div>

            {(isAssembly || (hasDrawing && isReviewStep)) && (
                <div className="sidebar-section sidebar-actions">
                    {isAssembly && (
                        <button className="sidebar-action-btn" onClick={onViewBom}>
                            View BOM
                        </button>
                    )}
                    {hasDrawing && isReviewStep && (
                        <button className="sidebar-action-btn" onClick={onViewDrawing}>
                            View Drawing
                        </button>
                    )}
                </div>
            )}
        </div>
    );
};

export default WizardSidebar;
